import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCheckCircleFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14 2.625A11.375 11.375 0 1 0 25.375 14 11.387 11.387 0 0 0 14 2.625Zm4.994 9.37-6.125 6.124a.876.876 0 0 1-1.238 0l-2.625-2.625a.876.876 0 0 1 1.238-1.238l2.006 2.007 5.506-5.507a.876.876 0 0 1 1.238 1.238Z" />
  </svg>
);
export default SvgCheckCircleFill;
